import { ProgramName } from '~/types';

export const getMetadataForProgram = (
  programName: ProgramName,
): { name: string; src: string } => {
  switch (programName) {
    case ProgramName.National: {
      return { name: 'The ACT® Test', src: '/static/img/products/TheACT.png' };
    }
    case ProgramName.Special: {
      return { name: 'The ACT® Test', src: '/static/img/products/TheACT.png' };
    }
    default: {
      return { name: 'The ACT® Test', src: '/static/img/products/TheACT.png' };
    }
  }
};

export default getMetadataForProgram;
